import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=c48c9760&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c48c9760')) {
      api.createRecord('c48c9760', component.options)
    } else {
      api.reload('c48c9760', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=c48c9760&", function () {
      api.rerender('c48c9760', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2BXS9vb2G7h7a/JS/comp/cancellationPolicy.vue"
export default component.exports